import { computed, ComputedRef, ref, Ref } from "vue";

interface ChangeTracker<T> {
  value: Ref<T>;
  hasChanged: ComputedRef<boolean>;
  resetInitialValue: () => void;
}

const useChangeTracker = <T>(initialValue: T): ChangeTracker<T> => {
  const value = ref(initialValue) as Ref<T>;
  const initialValueRef = ref(initialValue) as Ref<T>;

  // Value changed

  const resetInitialValue = () => {
    initialValueRef.value = value.value;
  };

  const hasChanged = computed(() => {
    if (typeof initialValue === "object") {
      return JSON.stringify(value.value) !== JSON.stringify(initialValue);
    } else {
      return value.value != initialValueRef.value;
    }
  });

  return {
    value,
    hasChanged,
    resetInitialValue,
  };
};

export default useChangeTracker;
